import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import DropdownActionButton from './dropdown-action-button';

import { changeDomainType } from '../../../common/actions/domain-management-action-creators';

export class ChangeDomainTypeButtonContainer extends Component{
    handleDomainTypeChange = ( domainType ) => {
        const { selectedDomains, changeDomainType } = this.props;

        const domains = selectedDomains.map( domain => domain.domainName );

        changeDomainType( domains, domainType );
    }

    render(){
        return (
            <DropdownActionButton
                automationId="domain-management-change-domain-type-button"
                handleSelectionChange={this.handleDomainTypeChange}
                type="domainType"
                text="Change domain type"
            />
        );
    }
};

ChangeDomainTypeButtonContainer.propTypes = {
    changeDomainType: PropTypes.func.isRequired,
    selectedDomains: PropTypes.array.isRequired,
};

export default connect( null, { changeDomainType } )( ChangeDomainTypeButtonContainer );
